import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../ricos-context';
import {
  getIsModalOpen,
  useModalService,
  useModalState,
} from './../../../ricos-modals/modal-service-provider';
import type { PluginContainerData_Alignment } from './../../../ricos-schema/legacy/wix/rich_content/v1';
import { DividerData_Width } from './../../../ricos-schema/legacy/wix/rich_content/v1';
import type { IToolbarItem } from './../../../ricos-types';
import { AlignmentPanel, DropdownButton } from './../../../toolbars-ui';

import { alignmentMap } from './dividerButtonsData';

const getDefaultAlignment = (langDir: $TSFixMe) => {
  return langDir === 'rtl' ? 'RIGHT' : 'LEFT';
};

type Props = {
  toolbarItem: IToolbarItem;
  id: string;
  dataHook?: string;
};

export const DividerAlignmentButton: FC<Props> = ({ toolbarItem, dataHook, id }) => {
  const { t, languageDir, isMobile } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));
  const node = toolbarItem.attributes.selectedNode;
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);
  const getSelectedAlignment: () => string = () =>
    node?.attrs?.alignment || getDefaultAlignment(languageDir);
  const selectedAlignment = getSelectedAlignment();
  const SelectedAlignmentIcon = alignmentMap[selectedAlignment as $TSFixMeKey<typeof alignmentMap>];
  const isButtonDisabled = node?.attrs?.width === DividerData_Width.LARGE;

  const closeModal = () => modalService.closeModal(id);

  const onAlignmentClick = (alignment: $TSFixMe) => {
    toolbarItem.commands?.click({ value: alignment });
    closeModal();
  };

  const onClick = () => {
    modalService.isModalOpen(id)
      ? closeModal()
      : modalService.openModal({
          id,
          Component: AlignmentPanel,
          componentProps: {
            options: ['LEFT', 'CENTER', 'RIGHT'] as PluginContainerData_Alignment[],
            getSelectedAlignment,
            onClick: onAlignmentClick,
          },
          layout: isMobile ? 'drawer' : 'toolbar',
          positioning: { referenceElement, placement: 'bottom' },
        });
  };

  return (
    <DropdownButton
      dataHook={dataHook}
      active={isModalOpen}
      onClick={onClick}
      disabled={isButtonDisabled}
      setRef={setReferenceElement}
      Icon={SelectedAlignmentIcon}
      tooltip={t('TextAlignmentButton_Tooltip')}
    />
  );
};
